import {
  FROSTED_BLACK,
  LIGHT_BLUE,
  LIGHT_GRAY,
  LOW_BLUE,
  LOW_GRAY,
  NEAR_WHITE,
} from "@shape/reef-shared";
import styled, { css } from "styled-components";

export const HelpDeskOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
`;

export const HelpDeskLink = styled.a<{ variant: "primary" | "secondary" }>`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: 0.2s ease;

  ${({ variant }) =>
    variant === "primary"
      ? css`
          background: ${LIGHT_BLUE};
          border: 1px solid ${LIGHT_BLUE};

          &:hover {
            background: ${LOW_BLUE};
            border-color: ${LOW_BLUE};
          }
        `
      : css`
          background: ${FROSTED_BLACK};
          border: 1px solid ${LIGHT_GRAY};

          &:hover {
            border-color: ${LOW_BLUE};

            .option-icon,
            .external-icon,
            strong {
              color: ${LOW_BLUE};
            }
          }
        `}

  &:focus-visible {
    outline: 2px solid ${NEAR_WHITE};
    outline-offset: 2px;
  }

  .option-icon {
    flex-shrink: 0;
    font-size: 20px;
    color: ${({ variant }) => (variant === "primary" ? NEAR_WHITE : LIGHT_BLUE)};
    transition: 0.2s ease;
  }

  .option-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;

    strong {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      color: ${NEAR_WHITE};
      transition: 0.2s ease;
    }

    small {
      font-size: 12px;
      line-height: 16px;
      color: ${({ variant }) => (variant === "primary" ? NEAR_WHITE : LOW_GRAY)};
    }
  }

  .external-icon {
    flex-shrink: 0;
    font-size: 12px;
    color: ${({ variant }) => (variant === "primary" ? NEAR_WHITE : LIGHT_GRAY)};
    transition: 0.2s ease;
  }
`;
